// localStorage keys
export const USER_KEY = 'skladovka-user';
export const REFRESH_KEY = 'skladovka-refresh';

export const APP_THEME = {
  token: {
    colorPrimary: '#ff6c48',
  },
};
